import PropTypes from 'prop-types';
import * as Styled from './Style';
/**
 * Шапка группы вопросов по сегменту
 */
const SegmentHeader = ({
  points,
  carrierName,
  rating
}) => /*#__PURE__*/React.createElement(Styled.SegmentHeader, null, /*#__PURE__*/React.createElement(Styled.FlexFirstPart, null, /*#__PURE__*/React.createElement(Styled.Direction, null, points[0].title, ' — ', points[points.length - 1].title), /*#__PURE__*/React.createElement(Styled.Date, null, I18n.l('date.formats.datetime', points[0].datetime))), /*#__PURE__*/React.createElement(Styled.Flex, null, /*#__PURE__*/React.createElement(Styled.Carrier, null, carrierName), rating['avg-rating'] && /*#__PURE__*/React.createElement(Styled.Rating, null, /*#__PURE__*/React.createElement(Styled.Icon, {
  className: "icon icon-star-full"
}), /*#__PURE__*/React.createElement("span", null, rating['avg-rating']))));
SegmentHeader.propTypes = {
  /** Остановки */points: PropTypes.arrayOf(PropTypes.shape({
    /** Город остановки */title: PropTypes.string,
    /** Время отправления от остановки */datetime: PropTypes.instanceOf(Date)
  })).isRequired,
  /** Имя перевозчика */carrierName: PropTypes.string,
  /** Рейтинг рейса */rating: PropTypes.objectOf(PropTypes.shape({
    /** Средний рейтинг */'avg-rating': PropTypes.string,
    /** Количество проголосовавших */'votes-count': PropTypes.string
  })).isRequired
};
export default SegmentHeader;